



















import { Component, Inject, Vue } from "vue-property-decorator";
import { IProductConfigProviderData } from "@/models/providers/products";
import { QUERY_PARAMS } from "@/data/constants";

@Component
export default class ProductShareLink extends Vue {
  // Inject

  @Inject({ from: "productConfigProviderData" })
  public readonly $productConfigData!: () => IProductConfigProviderData;

  // Computed

  public get config() {
    const $product = this.$productConfigData();
    const config = {};
    config[QUERY_PARAMS.CATEGORY_ID] = this.$_.get(
      $product,
      "product.category_id"
    );
    config[QUERY_PARAMS.PRODUCT_ID] = $product.productId;
    config[QUERY_PARAMS.QUANTITY] = this.$_.get($product, "config.quantity", 1);
    config[QUERY_PARAMS.BILLING_CYCLE_MONTHS] = this.$_.get(
      $product,
      "config.billing_cycle_months",
      1
    );

    const subproducts = this.$_.concat(
      this.$_.get($product, "config.attributes"),
      this.$_.get($product, "config.options")
    );

    if (subproducts.length) {
      config[QUERY_PARAMS.SUBPRODUCT_IDS] = this.$_.map(
        subproducts,
        subproduct => subproduct.product_id
      ).join(",");
      this.$_.forEach(this.$_.get($product, "config.options"), subproduct => {
        if (this.$_.has(subproduct, "unit_quantity")) {
          config[
            `${QUERY_PARAMS.SUBPRODUCT_QUANTITY}[${subproduct.product_id}]`
          ] = subproduct.unit_quantity;
        }
        return;
      });
    }

    return this.$_.map(config, (value, key) => {
      return `${key}=${value}`;
    }).join("&");
  }

  // Methods

  public async copyShareLink() {
    try {
      await this.$copyText(
        `${window.location.origin}/order/product?${this.config}`
      );
      this.$buefy.toast.open({
        message: this.$t("_.link_copied_to_clipboard") as string
      });
    } catch {
      // Slient catch
    }
  }
}
